// src/shared/components/ui/SocialLinks.tsx

import React from 'react';
import './SocialLinks.css';

interface SocialLink {
  name: string;
  icon: string;
  url: string;
  color: string;
}

interface SocialLinksProps {
  links?: SocialLink[];
  size?: 'small' | 'medium' | 'large';
  variant?: 'default' | 'minimal' | 'filled';
}

const defaultLinks: SocialLink[] = [
  {
    name: 'Website',
    icon: '🌐',
    url: '#',
    color: '#3498db'
  },
  {
    name: 'Facebook',
    icon: '📘',
    url: '#',
    color: '#1877f2'
  },
  {
    name: 'Instagram',
    icon: '📷',
    url: '#',
    color: '#e4405f'
  },
  {
    name: 'TikTok',
    icon: '🎵',
    url: '#',
    color: '#000000'
  }
];

const SocialLinks: React.FC<SocialLinksProps> = ({
  links = defaultLinks,
  size = 'medium',
  variant = 'default'
}) => {
  const handleLinkClick = (url: string, name: string) => {
    if (url === '#') {
      console.log(`${name} link clicked - URL not configured`);
      return;
    }
    
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={`social-links social-links--${size} social-links--${variant}`}>
      {links.map((social, index) => (
        <button
          key={index}
          className="social-link"
          style={{ '--social-color': social.color } as React.CSSProperties}
          title={social.name}
          onClick={() => handleLinkClick(social.url, social.name)}
          aria-label={`Visitar ${social.name}`}
        >
          <span className="social-icon">{social.icon}</span>
        </button>
      ))}
    </div>
  );
};

export default SocialLinks;